import React from "react";

import FormData from "./Components/FormData";
import Landing from "./Components/Landing/Landing";
import Router from "./Components/Router/Router";
import ViewInfo from "./Components/ViewInfo";

function App() {
  return (
    <div>
      {/* <FormData /> */}
      <Router />
      {/* <ViewInfo /> */}
    </div>
  );
}

export default App;
